+ (($) ->
  'use strict'
  TF_SORT = undefined
  container = undefined
  getUrlParameter = undefined
  relatedColumn = undefined
  relatedLabel = undefined
  sideBar = undefined
  container = $('#sort-layout-show-box')
  sideBar = $('#filter-bar-section')
  relatedColumn = $('.ticket-finder-schedule-col > ul')
  relatedLabel = $('.ticket-finder-schedule-col > h4')


  Number.isInteger = Number.isInteger || (value) ->
    typeof value is "number" and isFinite(value) and Math.floor(value) is value


  getUrlParameter = (sParam) ->
    i = undefined
    len = undefined
    sPageURL = undefined
    sParameterName = undefined
    sURLVariable = undefined
    sURLVariables = undefined
    sPageURL = decodeURIComponent(window.location.search.substring(1))
    sURLVariables = sPageURL.split('&')
    i = 0
    len = sURLVariables.length
    while i < len
      sURLVariable = sURLVariables[i]
      sParameterName = sURLVariable.split('=')
      if sParameterName[0] == sParam
        return sParameterName[0]
      i++
    return

  ### jshint undef: true, unused: false ###

  TF_SORT =
    init: ->
      inputForm = undefined
      @markupFirst()
      @triggerSearchByZipcode()
      @triggerSearchByZipcodeMobile()
      @typeToSort()
      @viewByArea()
      @viewAllAction()
      @viewByAreaMobile()
      inputForm = $('#type-to-search')
      @typeToSearchFocus inputForm
      inputForm = $('#type-to-search-mobile')
      @typeToSearchFocus inputForm
    columnAction: ->
      $.each $('.ticket-finder-schedule-col'), ->
        allLabel = undefined
        childHasVisibleItem = undefined
        childLength = undefined
        column = undefined
        item = undefined
        label = undefined
        result = undefined
        ulArea = undefined
        column = $(this)
        ulArea = column.find('.default_list')
        result = column.find('li:visible')
        item = column.find('li')
        childLength = item.length
        label = undefined
        allLabel = column.find('h4')
        childHasVisibleItem = false
        $.each item, ->
          if $(this).css('display') == 'block'
            childHasVisibleItem = true
            return label = $(this).parents('.default_list').prev()
          return
        if result.length < 1
          if childHasVisibleItem == true
            column.show()
          else
            column.hide()
        else
          column.show()
    typeToSort: ->
      $('#type-to-search').hideseek()
      $('#type-to-search').on '_after', ->
        TF_SORT.columnAction()
        TF_SORT.hideLabel()
    triggerSearchByZipcode: ->
      $('#type-to-search').keyup(->
        length = undefined
        searchVal = undefined
        zipcode = undefined
        console.log 'keyup now!'
        searchVal = $(this).val()
        length = searchVal.toString().length
        if Number.isInteger(Number(searchVal)) and length == 5
          zipcode = searchVal
          TF_SORT.searchByZipcode zipcode
        else
          TF_SORT.hideZipcodeResult()
      ).keydown (event) ->
        length = undefined
        searchVal = undefined
        zipcode = undefined
        if event.which == 13
          console.log 'keydown == 13'
          searchVal = $(this).val()
          length = searchVal.toString().length
          if Number.isInteger(Number(searchVal)) and length == 5
            if $('#ticket-finder-by-distance-ul').children().length == 0
              zipcode = searchVal
              return TF_SORT.searchByZipcode(zipcode)
          else
            return TF_SORT.hideZipcodeResult()
        return
    triggerSearchByZipcodeMobile: ->
      $('#type-to-search-mobile').keyup(->
        length = undefined
        searchVal = undefined
        zipcode = undefined
        console.log 'keyup now!'
        searchVal = $(this).val()
        length = searchVal.toString().length
        if Number.isInteger(Number(searchVal)) and length == 5
          zipcode = searchVal
          TF_SORT.searchByZipcode zipcode
        else
          TF_SORT.hideZipcodeResult()
      ).keydown (event) ->
        length = undefined
        searchVal = undefined
        zipcode = undefined
        if event.which == 13
          console.log 'keydown == 13'
          searchVal = $(this).val()
          length = searchVal.toString().length
          if Number.isInteger(Number(searchVal)) and length == 5
            if $('#ticket-finder-by-distance-ul').children().length == 0
              zipcode = searchVal
              return TF_SORT.searchByZipcode(zipcode)
          else
            return TF_SORT.hideZipcodeResult()
        return
    showLoading: ->
      new Promise((resolve, reject) ->
        $('.banner-loading').show()
        resolve()
)
    hideZipcodeResult: ->
      new Promise((resolve, reject) ->
        $('#ticket-finder-header-choice-distance-wrapper').hide()
        $('#ticket-finder-header-choice-region').attr 'checked', true
        selectByRegion()
        resolve()
)
    emptyResult: ->
      new Promise((resolve, reject) ->
        $('#ticket-finder-by-distance-ul').empty()
        resolve()
)
    preparePageshow: ->
      new Promise((resolve, reject) ->
        $('#ticket-finder-header-choice-distance-wrapper').show()
        $('#ticket-finder-header-choice-distance').attr 'checked', true
        selectByDistance()
        $('.view-by-area-checkbox-all').attr 'checked', true
        TF_SORT.checkedViewAll()
        resolve()
)
    searchByZipcode: (zipcode) ->
      eventType = undefined
      loadZipAjax = undefined
      prepareAjax = undefined
      shenyunEvent = undefined
      shenyunEvent = getUrlParameter('sy')
      eventType = if shenyunEvent then 1 else 2

      prepareAjax = ->
        new Promise((resolve, reject) ->
          $.getJSON '/event/ajax-get-nearby-cities-by-zip?zip=' + zipcode + '&type=' + eventType, ((data) ->
            i = undefined
            len = undefined
            resultCity = undefined
            x = undefined
            if $('#ticket-finder-by-distance-ul').children().length == 0
              i = 0
              len = data.length
              while i < len
                x = data[i]
                resultCity = x.name
                $.each $('.city-name-label'), (index, value) ->
                  if resultCity == $(this).text()
                    $(this).parents('li').show()
                    TF_SORT.columnAction()
                    return TF_SORT.hideLabel()
                  return
                $.each $('#ticket-finder-by-schedule .city-name-label'), (index, value) ->
                  if resultCity == $(this).text()
                    return $(this).parents('li').clone().appendTo('#ticket-finder-by-distance-ul')
                  return
                i++
              resolve()
            else
              reject()
          ), 'json'
)

      loadZipAjax = ->
        Promise.all [
          TF_SORT.showLoading()
          TF_SORT.emptyResult()
          TF_SORT.preparePageshow()
          prepareAjax()
        ]

      loadZipAjax().then ->
        $('.banner-loading').hide()
    typeToSearchFocus: (inputForm) ->
      inputForm.on
        focus: ->
          $(this).parent().removeClass 'show-search-icon'
          $(this).attr 'placeholder', ''
        blur: ->
          $(this).parent().addClass 'show-search-icon'
          $(this).attr 'placeholder', $(this).data('value')
    markupFirst: ->
      $('ul.united-states').parent().addClass 'united-states'
      $('ul.canada').parent().addClass 'canada-col'
      $('ul.asia').parent().addClass 'asia-col'
    cleanSearchResult: ->
      press = undefined
      $('#type-to-search').val('').trigger 'keyup'
      press = jQuery.Event('keypress')
      press.bubbles = true
      press.cancelable = true
      press.charCode = 8
      press.currentTarget = $('#type-to-search')[0]
      press.eventPhase = 2
      press.keyCode = 8
      press.returnValue = true
      press.srcElement = $('#type-to-search')[0]
      press.target = $('#type-to-search')[0]
      press.type = 'keyup'
      press.view = Window
      press.which = 8
      $('#type-to-search').trigger press
    viewByArea: ->
      areaInArray = undefined
      areaInArray = ''
      $('.view-by-area-checkbox').each ->
        area = undefined
        checkMe = undefined
        checkMe = $(this)
        area = checkMe.attr('data-area')
        checkMe.change ->
          afterUncheckOutputArea = undefined
          firstOutputArea = undefined
          newArea = undefined
          outputArea = undefined
          outputAreaArrayString = undefined
          if checkMe.prop('checked')
            if $('#type-to-search').val().length > 0
              TF_SORT.cleanSearchResult()
            $('.view-by-area-checkbox-all').attr 'checked', false
            firstOutputArea = container.attr('data-select')
            areaInArray = firstOutputArea + '.' + area + ','
            container.attr 'data-select', areaInArray
            outputArea = container.attr('data-select')
            outputAreaArrayString = outputArea.substring(0, outputArea.length - 1)
            console.log 'checkMe.prop is checked=' + checkMe.prop('checked')
          else
            outputArea = container.attr('data-select')
            newArea = outputArea.replace('.' + area + ',', '')
            container.attr 'data-select', newArea
            afterUncheckOutputArea = container.attr('data-select')
            outputAreaArrayString = afterUncheckOutputArea.substring(0, afterUncheckOutputArea.length - 1)
            relatedColumn.hide()
            relatedLabel.hide()
            console.log 'checkMe.prop isnt checked=' + checkMe.prop('checked')
            $(outputAreaArrayString).show()
            TF_SORT.showHideParent()
            TF_SORT.addColumnStyle()
            TF_SORT.fixedNoCheckedIssue()
    checkedViewAll: ->
      container.attr 'data-select', ''
      $('.view-by-area-checkbox').attr 'checked', false
      relatedColumn.show()
      relatedLabel.show()
      TF_SORT.showHideParent()
      TF_SORT.addColumnStyle()
    viewAllAction: ->
      $('.view-by-area-checkbox-all').change ->
        if $(this).prop('checked')
          TF_SORT.checkedViewAll()
        else
          $('.view-by-area-checkbox').attr 'checked', false
    viewByAreaMobile: ->
      selectMe = undefined
      selectMe = $('#view-by-area-mobile select')
      selectMe.on change: ->
        $('select option:selected').each ->
          area = undefined
          areaInArray = undefined
          area = $(this).attr('data-area')
          areaInArray = '.' + area
          container.attr 'data-select', areaInArray
          relatedColumn.hide()
          relatedLabel.hide()
          $(areaInArray).show()
          TF_SORT.showHideParent()
          TF_SORT.addColumnStyle()
          if area == 'all'
            container.attr 'data-select', ''
            relatedColumn.show()
            relatedLabel.show()
            TF_SORT.showHideParent()
            return TF_SORT.addColumnStyle()
          return
    showHideParent: ->
      $('.sort-layout-col').each ->
        childHasVisibleDiv = undefined
        childLength = undefined
        hiddenChildLength = undefined
        childLength = $(this).find('.default_list').length
        hiddenChildLength = $(this).find('.default_list:hidden').length
        childHasVisibleDiv = false
        $.each $(this).find('.default_list'), (index, value) ->
          if $(this).css('display') == 'block'
            return childHasVisibleDiv = true
          return
        if hiddenChildLength == childLength
          if childHasVisibleDiv == true
            $(this).show()
          else
            $(this).hide()
        else
          $(this).show()
    addColumnStyle: ->
      eachAction = undefined
      i = undefined
      len = undefined
      results = undefined
      seasonShowsBlocks = undefined
      x = undefined
      seasonShowsBlocks = $('.season-shows-block')
      results = []
      i = 0
      len = seasonShowsBlocks.length
      while i < len
        x = seasonShowsBlocks[i]

        eachAction = ->
          visibleCol = undefined
          visibleCol = $(x).find('.sort-layout-col').filter(':visible').length
          switch visibleCol
            when 1
              $(x).removeClass 'two-row-col'
              return $(x).addClass('full-row-col')
            when 2
              $(x).removeClass 'full-row-col'
              return $(x).addClass('two-row-col')
            else
              $(x).removeClass 'full-row-col'
              return $(x).removeClass('two-row-col')
          return

        results.push eachAction()
        i++
      results
    hideLabel: ->
      $('.default_list').each ->
        childHasVisibleDiv = undefined
        childLength = undefined
        hiddenChildLength = undefined
        label = undefined
        childLength = $(this).find('li').length
        hiddenChildLength = $(this).find('li:hidden').length
        label = $(this).prev()
        childHasVisibleDiv = false
        $.each $(this).find('li'), ->
          if $(this).css('display') == 'block'
            return childHasVisibleDiv = true
          return
        if hiddenChildLength == childLength
          if childHasVisibleDiv == true
            label.show()
          else
            label.hide()
        else
          label.show()
    fixedNoCheckedIssue: ->
      container = $('#sort-layout-show-box')
      if container.attr('data-select') == ''
        $('.view-by-area-checkbox-all').attr 'checked', true
        relatedColumn.show()
        relatedLabel.show()
        TF_SORT.showHideParent()
        return TF_SORT.addColumnStyle()
      return
  $ ->
    TF_SORT.init()
)(jQuery)
# ---
# generated by coffee-script 1.9.2

# ---
# generated by js2coffee 2.2.0